/**
 * Mirrors `Vidhyantra_Backend/rbac/catalog/seed-permission-keys.ts` stem lists only (keep in sync manually).
 */

export const ACTIONS = ['view', 'create', 'edit', 'delete'] as const

export const DOMAINS = [
  'students',
  'attendance',
  'exams',
  'timetable',
  'fees',
  'billing',
  'payments',
  'users',
  'roles',
  'hr',
  'transport',
  'hostel',
  'library',
  'inventory',
  'communication',
  'settings',
  'audit',
  'reports',
] as const

export const SCOPES = ['platform', 'organization', 'branch'] as const
